// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__G72zU","icon":"SortAdornment_icon__2-oAs","up":"SortAdornment_up__1BhWU","down":"SortAdornment_down__DpNEm","active":"SortAdornment_active__14dLl"};